import { useState } from "react";
import useMerchantPortalAxios from "../utils/axios";

const StatementOfAccountAPI = () => {
    const MerchantPortalAxios = useMerchantPortalAxios();
    const [GetStatementData, SetStatementData] = useState([]);
    const [totalNbOfPage, SetTotalNbOfPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [soaLoading, setSoaLoading] = useState(true);

    const [exportData, setExportData] = useState(null);

    async function GetSOAList(CurrencyID , pageNb ,dateFrom, dateTo, transactionType) {
        setSoaLoading(true);
        await MerchantPortalAxios.post(
            `/v1/StatementOfAccount/GetSOAList`,
            {
                SessionID: sessionStorage.getItem("SessionID"),
                CurrencyID: CurrencyID,
                page: pageNb,
                pageSize: 10,
                DateFrom: dateFrom,
                DateTo: dateTo,
                TransactionType: transactionType
            }
        ).then((res) => {
            SetStatementData(res.data.Payload.StatementsOfAccount);
            if(res.data.Payload.StatementsOfAccount?.length === 0){
                SetTotalNbOfPage(0);
                setTotalCount(0);
            } else{
                SetTotalNbOfPage(res.data.Payload.StatementsOfAccount[0].TotalPages);
                setTotalCount(res.data.Payload.StatementsOfAccount[0].TotalCount);
            }
            setSoaLoading(false);
        });
    }

    const dateFormat = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString();
    };

    const timeFormat = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleTimeString();
    };

    async function getSOExport(CurrencyID ,dateFrom, dateTo, transactionType) {
        await MerchantPortalAxios.post(
            `/v1/StatementOfAccount/GetSOAList`,
            {
                SessionID: sessionStorage.getItem("SessionID"),
                CurrencyID: CurrencyID,
                page: 1,
                pageSize: 1,
                DateFrom: dateFrom,
                DateTo: dateTo,
                TransactionType: transactionType,
                isExport: true
            }
        ).then((res) => {
            const updatedData = res.data.Payload.StatementsOfAccount.map(item => {
                const {Row, TotalPages, TotalCount, PaymentDate, ...rest} = item;
                const formattedPaymentDate = new Date(PaymentDate);

                if (!isNaN(formattedPaymentDate.getTime())) {
                    rest.PaymentDate = dateFormat(formattedPaymentDate);
                    rest.PaymentTime = timeFormat(formattedPaymentDate);
                }

                return rest;
            });

            setExportData(updatedData);
        });
    }

    return {
        GetSOAList,
        GetStatementData,
        totalNbOfPage,
        totalCount,
        soaLoading,
        getSOExport,
        exportData,
        setExportData
    };
};

export default StatementOfAccountAPI;
